import React from "react";
import { useScreenSize } from "../../../utils/media-query";
import Toolbar, { Item } from "devextreme-react/toolbar";
import DataGrid, { Column, Paging, Pager } from "devextreme-react/data-grid";
import "./style.scss";
import { formatMessage } from "devextreme/localization";

export default function DataGridApproval({ dataTable }) {
  const { isXSmall } = useScreenSize();
  return (
    <div>
      <Toolbar className="mt-4 mb-1">
        <Item location="before">
          <div className="fw-bold text-uppercase">
            {formatMessage("LeaveSummary")}
          </div>
        </Item>
      </Toolbar>
      <DataGrid
        showBorders={true}
        showRowLines={true}
        hoverStateEnabled={true}
        rowAlternationEnabled={true}
        columnAutoWidth={true}
        columnHidingEnabled={true}
        // columnResizingMode="widget"
        allowColumnResizing={true}
        alignment="center"
        dataSource={dataTable}
        className="datagrid-has-toolbar-actions"
      >
        <Paging defaultPageSize={2} />
        <Pager
          showPageSizeSelector={true}
          allowedPageSizes={[5, 10, 20]}
          showInfo={true}
        />
        <Column
          caption={formatMessage("Year")}
          dataField="Year"
          dataType="string"
          hidingPriority={isXSmall ? 1 : false}
        />
        <Column
          caption={formatMessage("LeaveSymbol")}
          dataField="LeaveSymbol"
          dataType="string"
          hidingPriority={isXSmall ? 3 : false}
        />
        <Column
          caption={formatMessage("Total")}
          dataField="TotalLeaveYear"
          dataType="string"
          hidingPriority={isXSmall ? 4 : false}
        />
        <Column
          caption={formatMessage("Used")}
          dataField="LeavePesonalUsed"
          hidingPriority={isXSmall ? 5 : false}
        />
        <Column
          caption={formatMessage("LeaveRemain")}
          dataField="LeaveRemain"
          hidingPriority={isXSmall ? 5 : false}
        />
        <Column
          caption={formatMessage("Jan")}
          dataField="T1"
          hidingPriority={isXSmall ? 5 : false}
          width={70}
        />
        <Column
          caption={formatMessage("Feb")}
          dataField="T2"
          hidingPriority={isXSmall ? 5 : false}
          width={70}
        />
        <Column
          caption={formatMessage("Mar")}
          dataField="T3"
          hidingPriority={isXSmall ? 5 : false}
          width={70}
        />
        <Column
          caption={formatMessage("Apr")}
          dataField="T4"
          hidingPriority={isXSmall ? 5 : false}
          width={70}
        />
        <Column
          caption={formatMessage("May")}
          dataField="T5"
          hidingPriority={isXSmall ? 5 : false}
          width={70}
        />
        <Column
          caption={formatMessage("Jun")}
          dataField="T6"
          hidingPriority={isXSmall ? 5 : false}
          width={70}
        />
        <Column
          caption={formatMessage("Jul")}
          dataField="T7"
          hidingPriority={isXSmall ? 5 : false}
          width={70}
        />
        <Column
          caption={formatMessage("Aug")}
          dataField="T8"
          hidingPriority={isXSmall ? 5 : false}
          width={70}
        />
        <Column
          caption={formatMessage("Sep")}
          dataField="T9"
          hidingPriority={isXSmall ? 5 : false}
          width={70}
        />
        <Column
          caption={formatMessage("Oct")}
          dataField="T10"
          hidingPriority={isXSmall ? 5 : false}
          width={70}
        />
        <Column
          caption={formatMessage("Nov")}
          dataField="T11"
          hidingPriority={isXSmall ? 5 : false}
          width={70}
        />
        <Column
          caption={formatMessage("Dec")}
          dataField="T12"
          hidingPriority={isXSmall ? 5 : false}
          width={70}
        />
      </DataGrid>
    </div>
  );
}
